<div>
  <div class="groups">
    <div class="group">
      <mat-checkbox (change)="$event ? masterToggle('brics') : null"
                    [checked]="selection.hasValue() && isAllSelected('brics')"
      ><b>БРИКС</b>
      </mat-checkbox>
    </div>
    <div class="group">
      <mat-checkbox (change)="$event ? masterToggle('eaes') : null"
                    [checked]="selection.hasValue() && isAllSelected('eaes')"
      ><b>ЕАЭС</b>
      </mat-checkbox>
    </div>
  </div>
  <mat-dialog-content>
    <div>
      <div class="controls">
        <div class="countries">
          <div *ngFor="let row of countries; let i=index" class="country">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(row) : null"
                          [checked]="selection.isSelected(row)"
            > {{ row.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button mat-raised-button
              color="primary"
              [disabled]="!isValid"
              (click)="complete()">{{ buttonLabel }}
      </button>
      <span class="var-label">
        {{ varLabel }}
      </span>
    </div>
  </mat-dialog-actions>
</div>
